<template>
    <b-modal
        v-on:ok="commitAsset"
        v-on:cancel="closeAssetModal"
        v-on:hide="closeAssetModal"
        :visible="fileModalOpen"
        body-class="p-0"
        modal-class="asset-modal"
        ok-title="confirm"
        size="xl" title="Asset Manager">
        <p v-if="initialized">Loading...</p>
        <div v-else>
            <file-manager-component
                v-if="fileModalOpen"
                v-on:fm::asset::select="selectAsset"
                v-on:fm::asset::dblclick="pickSelectAsset"
                :content="content"
                :timestamp="timestamp"
                :currentValue="currentAsset"

                :getData="getData"
                :replaceData="replaceData"
                :createData="modifiedCreateData"
                :updateBatch="modifiedUpdateBatch"

                :addNotification="addNotification"
                :allowedExtensions="config.extensions"
                :multiple="config.multiple"
                :storagePanel="config.storagePanel"
                :storages="config.storages"
                :embedded="true"
                :hide="!fileModalOpen"
                ></file-manager-component>
        </div>
    </b-modal>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';
import FileManagerComponent from '../AssetManagerComponent';

export default {
    data() {
        return {
            localTimestamp: Date.now(),
        }
    },

    components: {
        FileManagerComponent,
    },

    watch: {

    },

    mounted() {
        if (!this.content && !this.loading) {
            this.getData();
        }
    },

    computed: {
        ...Vuex.mapGetters('assets', {
            content: 'content',
            loading: 'loading',
            timestamp: 'timestamp',
            selectingAsset: 'selectingAsset',
            selectedAsset: 'selectedAsset',
            fileModalOpen: 'fileModalOpen',
            fileModalConfig: 'fileModalConfig',
        }),

        initialized() {
            return !this.content;
        },

        config() {
            return {
                multiple: false,
                extensions: [
                    'png', 'jpg', 'jpeg', 'svg',
                    'docx', 'doc', 'pdf', 'csv',
                ],
                ...(this.fileModalConfig || {}),
            }
        },

        currentAsset() {
            if (_.isObject(this.selectedAsset)) {
                return _.get(this.selectedAsset, 'id', null);
            }
            return this.selectedAsset;
        }
    },

    methods: {
        ...Vuex.mapActions('assets', [
            'getData', 'createData',
            'updateBatch', 'replaceData',
            'selectAsset', 'commitAsset',
            'closeAssetModal', 'openAssetModal',
            'configAssetModal', 'addNotification',
        ]),

        // modify top level API methods so that
        // they accept multiple arguments instead of just 1
        modifiedCreateData(data, options) {
            return this.createData({ data, options });
        },

        modifiedUpdateData(data, options) {
            return this.updateData({ data, options });
        },

        modifiedUpdateBatch(data, options) {
            return this.updateBatch({ data, options });
        },

        pickSelectAsset(value) {
            this.selectAsset(value);
            this.commitAsset();
            this.closeAssetModal();
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/GlobalFileModalComponent.vue